import "./App.css";
import Footer from "./components/footer/footer";
import NavBar from "./components/navBar/navBar";
import AppRouter from "./routes/routes";

function App() {
  return (
    <div className="App">
      <NavBar />
      <div className="routes">
        <AppRouter />
      </div>
      <Footer />
    </div>
  );
}

export default App;
